import { Component } from '@plone/volto/components';
import moment from 'moment';
import { useIntl } from 'react-intl';

export const NewsItemGridListingItemTemplate = (props) => {
  const { item, featured } = props;
  const intl = useIntl();
  moment.locale(intl.locale);
  return (
    <div className="card-container item-news">
      {item.image_field !== '' && (
        <Component
          componentName="PreviewImage"
          item={item}
          alt=""
          className="item-image"
        />
      )}
      <div className="item">
        <div className="content">
          {item?.head_title && (
            <div className="headline">{item.head_title}</div>
          )}
          {featured ? (
            <h3>{item.title || item.id}</h3>
          ) : (
            <h4>{item.title || item.id}</h4>
          )}
          {item.effective && (
            <div className="date">{moment(item?.effective).format('LL')}</div>
          )}
        </div>
      </div>
    </div>
  );
};
